(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Loop through all forms containing the address fields
    document.querySelectorAll('form').forEach(function (form) {
      // Handle country select elements within the form
      form.querySelectorAll('select[data-address-country-select]').forEach(function (countrySelect) {
        // Get the default country value from the data-default attribute
        const defaultCountry = countrySelect.getAttribute('data-default');

        if (defaultCountry) {
          // Find the option that matches the data-default either by value or text
          const matchingOption = Array.from(countrySelect.options).find(
            (option) => option.value === defaultCountry || option.text.trim() === defaultCountry,
          );

          if (matchingOption) {
            // Set the selected option
            countrySelect.value = matchingOption.value;

            // Trigger a change event to load provinces if necessary
            const changeEvent = new Event('change');
            countrySelect.dispatchEvent(changeEvent);
          }
        }
      });

      // Handle provinces loading if there's any dynamic province select logic
      form.querySelectorAll('select[name="address[province]"]').forEach(function (provinceSelect) {
        const defaultProvince = provinceSelect.getAttribute('data-default');

        if (defaultProvince) {
          // Find the option that matches the data-default either by value or text
          const matchingOption = Array.from(provinceSelect.options).find(
            (option) => option.value === defaultProvince || option.text.trim() === defaultProvince,
          );

          if (matchingOption) {
            // Set the selected province
            provinceSelect.value = matchingOption.value;
          }
        }
      });

      // Handle default address checkbox
      const defaultAddressCheckbox = form.querySelector('input[name="address[default]"]');
      if (defaultAddressCheckbox) {
        const isDefault = defaultAddressCheckbox.getAttribute('data-default') === 'true';
        defaultAddressCheckbox.checked = isDefault;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const isEditor = !!(window.Shopify && Shopify.designMode);

    const debounce = (fn, delay = 250) => {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    };

    const getSection = () => document.querySelector('#product-recommendations');

    const fetchRecommendations = async (targetNode) => {
      try {
        if (!targetNode) targetNode = getSection();
        if (!targetNode) return;

        var skeletonEl = targetNode.closest('[id^="shopify-section-"]');
        var skel = skeletonEl ? skeletonEl.querySelector('.pr-skeleton') : null;

        const url = targetNode.dataset.url;
        if (!url) return console.warn('[PR] Missing data-url');

        const res = await fetch(url, { cache: 'no-store' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();

        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newContent = temp.querySelector('.product-recommendations');
        if (!newContent) return;

        if (newContent.querySelector('.swiper-slide')) {
          targetNode.innerHTML = newContent.innerHTML;
          if (skel) skel.style.display = 'none';
          console.info('[PR] Updated');
        } else {
          if (skel) skel.style.display = '';
          const mainSection = document.querySelector('.product-recommendations');
          mainSection.style.display = 'none';
          console.info('[PR] No products — showing skeleton');
          return;
        }

        setTimeout(() => {
          if (typeof initializeMuskPRODUCTRECOMMENDATION === 'function') {
            initializeMuskPRODUCTRECOMMENDATION();
            console.info('[PR] init re-run');
          }
        }, 150);
      } catch (err) {
        console.error('[PR] fetchRecommendations error:', err);
        var skeletonEl = targetNode ? targetNode.closest('[id^="shopify-section-"]') : null;
        var skel = skeletonEl ? skeletonEl.querySelector('.pr-skeleton') : null;
        if (skel) skel.style.display = '';
      }
    };

    const initObserver = () => {
      const section = getSection();
      if (!section) return;

      if ('IntersectionObserver' in window && !isEditor) {
        const observer = new IntersectionObserver(
          (entries, obs) => {
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
              obs.unobserve(entry.target);
              fetchRecommendations(entry.target);
            }
          },
          { rootMargin: '0px 0px 200px 0px' },
        );
        observer.observe(section);
      } else {
        fetchRecommendations(section);
      }
    };

    const setupEditorListeners = () => {
      const safeReload = debounce(() => {
        const section = getSection();
        if (section) fetchRecommendations(section);
        else console.info('[PR] No section found — waiting...');
      }, 500);

      const events = [
        'shopify:section:load',
        'shopify:section:select',
        'shopify:block:select',
        'shopify:section:reorder',
        'shopify:section:deselect',
        'shopify:inspector:save',
      ];

      events.forEach((e) => {
        document.addEventListener(e, safeReload);
      });

      // Recheck every few seconds if section appears (for page switch in editor)
      if (isEditor) {
        setInterval(() => {
          const section = getSection();
          if (section && !section.dataset.initialized) {
            section.dataset.initialized = 'true';
            console.info('[PR] Section detected after save — reinit');
            initObserver();
          }
        }, 2000);
      }
    };

    const init = () => {
      const section = getSection();
      if (!section) {
        console.info('[PR] No product recommendations section found');
        if (isEditor) setupEditorListeners(); // ensure listeners still bind
        return;
      }
      initObserver();
      if (isEditor) setupEditorListeners();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-review-feed"] && !Shopify.designMode) return;
  try {
    
  class VideoReviewGrid extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.video-review-feed');

      this.cards = Array.from(this.querySelectorAll('[data-vrf-card]'));
      this.modal = root.querySelector('[data-vrf-modal]');
      this.reelsContainer = this.modal.querySelector('[data-vrf-reels]');
      this.reels = Array.from(this.modal.querySelectorAll('[data-vrf-reel]'));
      this.closeBtn = this.modal.querySelector('[data-vrf-close]');
      this.muteBtn = this.modal.querySelector('[data-vrf-mute]');
      this.prevBtn = this.modal.querySelector('[data-vrf-prev]');
      this.nextBtn = this.modal.querySelector('[data-vrf-next]');

      this.activeReelIndex = 0;
      this.modalMuted = false;
      this.modalPlaybackToken = 0;

      this.handleClose = this.handleClose.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleMuteToggle = this.handleMuteToggle.bind(this);
      this.handleWindowFocus = this.handleWindowFocus.bind(this);

      this.closeBtn.addEventListener('click', this.handleClose);
      this.muteBtn.addEventListener('click', this.handleMuteToggle);
      this.prevBtn.addEventListener('click', () => this.#goToReel(this.activeReelIndex - 1));
      this.nextBtn.addEventListener('click', () => this.#goToReel(this.activeReelIndex + 1));

      this.modal.addEventListener('close', () => this.#onModalClose());
      this.modal.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.handleClose();
      });

      for (const card of this.cards) {
        const index = this.cards.indexOf(card);
        const openTriggers = card.querySelectorAll('[data-vrf-open]');
        const soundBtn = card.querySelector('[data-vrf-sound]');

        for (const trigger of openTriggers) {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.#openModal(index);
          });
        }

        if (soundBtn) {
          soundBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.#toggleCardSound(card);
          });
        }
      }

      for (const reel of this.reels) {
        const playBtn = reel.querySelector('[data-vrf-reel-play]');
        if (playBtn) {
          playBtn.addEventListener('click', () => this.#toggleReelPlayback(reel));
        }
      }

      this.#initGridIntersection();
      this.#initReelIntersection();
      this.#playVisibleCards();

      this.modalMuted = true;
      this.modal.classList.remove('is-unmuted');

      window.addEventListener('focus', this.handleWindowFocus, { passive: true });
    }

    /* ── Grid tile behavior ──────────────────────────────────────────────────── */

    #prepareVideo(video, muted = true) {
      if (!video) return;

      video.muted = muted;
      video.defaultMuted = muted;
      video.loop = true;
      video.playsInline = true;
      video.autoplay = true;
      video.preload = 'metadata';
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');

      if (muted) {
        video.setAttribute('muted', '');
      } else {
        video.removeAttribute('muted');
      }
    }

    #bindCardVideoState(card, video) {
      if (!video || video.dataset.vrfStateBound === 'true') return;

      video.dataset.vrfStateBound = 'true';

      video.addEventListener('playing', () => {
        card.dataset.vrfLastPlayError = '';
        card.classList.add('is-playing');
      });

      video.addEventListener('pause', () => {
        card.classList.remove('is-playing');
      });

      video.addEventListener('ended', () => {
        card.classList.remove('is-playing');
      });

      video.addEventListener('error', () => {
        card.classList.remove('is-playing');
      });
    }

    #loadCardSrc(card) {
      const video = card.querySelector('[data-vrf-video]');
      if (!video) return video;

      this.#prepareVideo(video, !card.classList.contains('is-unmuted'));
      this.#bindCardVideoState(card, video);

      if (video.currentSrc || video.getAttribute('src') || video.src || video.querySelector('source')) return video;

      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      const src = isMobile ? card.dataset.vrfMobileSrc : card.dataset.vrfSrc;

      if (src) {
        video.src = src;
        video.load();
      }

      return video;
    }

    #playCard(card) {
      const video = this.#loadCardSrc(card);
      if (!video) return;

      this.#prepareVideo(video, !card.classList.contains('is-unmuted'));
      this.#bindCardVideoState(card, video);

      const promise = video.play();

      if (promise && typeof promise.then === 'function') {
        promise
          .then(() => {
            card.dataset.vrfLastPlayError = '';
            if (!video.paused) card.classList.add('is-playing');
          })
          .catch((error) => {
            card.dataset.vrfLastPlayError = error ? (error.name || error.message || 'play failed') : 'play failed';
            card.classList.remove('is-playing');

            const retry = () => {
              if (!this.#isCardNearViewport(card)) return;
              video.play()
                .then(() => {
                  card.dataset.vrfLastPlayError = '';
                  if (!video.paused) card.classList.add('is-playing');
                })
                .catch((retryError) => {
                  card.dataset.vrfLastPlayError = retryError ? (retryError.name || retryError.message || 'play failed') : 'play failed';
                  card.classList.remove('is-playing');
                });
            };

            video.addEventListener('loadedmetadata', retry, { once: true });
            video.addEventListener('canplay', retry, { once: true });
          });
      } else if (!video.paused) {
        card.classList.add('is-playing');
      }
    }

    #requestCardAutoplay(card) {
      this.#playCard(card);
    }

    #pauseCard(card) {
      const video = card.querySelector('[data-vrf-video]');
      if (video && !video.paused) video.pause();
      card.classList.remove('is-playing');
    }

    #toggleCardPlayback(card) {
      const video = card.querySelector('[data-vrf-video]');
      if (!video) return;

      if (video.paused) {
        this.#playCard(card);
      } else {
        this.#pauseCard(card);
      }
    }

    #toggleCardSound(card) {
      const video = card.querySelector('[data-vrf-video]');
      if (!video) return;

      const unmuting = !card.classList.contains('is-unmuted');

      if (unmuting) {
        for (const c of this.cards) {
          if (c === card) continue;
          c.classList.remove('is-unmuted');
          const v = c.querySelector('[data-vrf-video]');
          if (v) v.muted = true;
        }
      }

      video.muted = !unmuting;
      card.classList.toggle('is-unmuted', unmuting);
      const soundBtn = card.querySelector('[data-vrf-sound]');
      if (soundBtn) soundBtn.setAttribute('aria-pressed', String(unmuting));

      if (unmuting && video.paused) this.#playCard(card);
    }

    #isCardNearViewport(card) {
      const rect = card.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      return rect.bottom > -160 && rect.top < viewportHeight + 160 && rect.right > 0 && rect.left < viewportWidth;
    }

    #playVisibleCards() {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;

      for (const card of this.cards) {
        if (!card.querySelector('[data-vrf-video]')) continue;

        if (this.#isCardNearViewport(card)) {
          const visibleIndex = Array.from(this.cards).filter((candidate) => {
            return candidate.querySelector('[data-vrf-video]') && this.#isCardNearViewport(candidate);
          }).indexOf(card);

          window.setTimeout(() => this.#requestCardAutoplay(card), Math.max(visibleIndex, 0) * 180);
        } else {
          this.#pauseCard(card);
          card.classList.remove('is-unmuted');
          const video = card.querySelector('[data-vrf-video]');
          if (video) video.muted = true;
        }
      }
    }

    #initGridIntersection() {
      if (!('IntersectionObserver' in window)) {
        this.#playVisibleCards();
        return;
      }

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;

      const observer = new IntersectionObserver(
        (entries) => {
          let shouldSync = false;

          for (const entry of entries) {
            const card = entry.target;
            if (!card.querySelector('[data-vrf-video]')) continue;

            shouldSync = true;

            if (!entry.isIntersecting) {
              card.classList.remove('is-unmuted');
              const v = card.querySelector('[data-vrf-video]');
              if (v) v.muted = true;
            }
          }

          if (shouldSync) requestAnimationFrame(() => this.#playVisibleCards());
        },
        { rootMargin: '160px 0px', threshold: 0.4 }
      );

      for (const card of this.cards) {
        if (card.querySelector('[data-vrf-video]')) observer.observe(card);
      }

      this.gridObserver = observer;

      requestAnimationFrame(() => this.#playVisibleCards());
    }

    /* ── Modal reel behavior ─────────────────────────────────────────────────── */

    handleClose() {
      this.#stopAllReels(true);
      if (this.modal.open) this.modal.close();
    }

    handleKeydown(event) {
      if (!this.modal.open) return;

      if (event.key === 'ArrowDown' || event.key === 'PageDown') {
        event.preventDefault();
        this.#goToReel(this.activeReelIndex + 1);
      } else if (event.key === 'ArrowUp' || event.key === 'PageUp') {
        event.preventDefault();
        this.#goToReel(this.activeReelIndex - 1);
      } else if (event.key === 'm' || event.key === 'M') {
        this.handleMuteToggle();
      } else if (event.key === 'Escape') {
        this.handleClose();
      }
    }

    handleMuteToggle() {
      this.modalMuted = !this.modalMuted;
      this.modal.classList.toggle('is-unmuted', !this.modalMuted);
      this.muteBtn.setAttribute('aria-label', this.modalMuted ? 'Unmute' : 'Mute');

      for (const reel of this.reels) {
        const video = reel.querySelector('[data-vrf-reel-video]');
        if (video) video.muted = this.modalMuted;
      }
    }

    handleWindowFocus() {
      this.#playVisibleCards();
    }

    #openModal(index) {
      this.modalPlaybackToken += 1;

      for (const c of this.cards) {
        const v = c.querySelector('[data-vrf-video]');
        if (v && !v.paused) v.pause();
        c.classList.remove('is-playing');
      }

      this.activeReelIndex = Math.max(0, Math.min(index, this.reels.length - 1));

      /* Audio ON when the modal opens — the click that opened it counts as a user gesture */
      this.modalMuted = false;
      this.modal.classList.add('is-unmuted');

      this.modal.showModal();

      const openToken = this.modalPlaybackToken;
      requestAnimationFrame(() => {
        if (!this.modal.open || openToken !== this.modalPlaybackToken) return;

        const target = this.reels[this.activeReelIndex];
        if (target) {
          this.reelsContainer.scrollTo({ top: target.offsetTop, behavior: 'instant' });
          this.#playReel(target);
        }
        this.#updateNavState();
      });

      document.addEventListener('keydown', this.handleKeydown);
    }

    #onModalClose() {
      this.modalPlaybackToken += 1;
      this.modalMuted = true;
      this.modal.classList.remove('is-unmuted');
      this.#stopAllReels(true);
      this.#playVisibleCards();

      document.removeEventListener('keydown', this.handleKeydown);
    }

    #stopAllReels(resetPlayback = false) {
      for (const reel of this.reels) {
        const video = reel.querySelector('[data-vrf-reel-video]');
        if (video) {
          video.pause();
          video.muted = true;
          video.defaultMuted = true;
          video.removeAttribute('autoplay');
          video.setAttribute('muted', '');
          video.removeAttribute('src');

          if (resetPlayback) {
            try {
              video.currentTime = 0;
            } catch (error) {
              /* Some browsers reject currentTime before metadata is ready. */
            }

            video.load();
          }
        }
        reel.classList.remove('is-playing');
      }
    }

    #goToReel(index) {
      const target = this.reels[index];
      if (!target) return;
      this.reelsContainer.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
    }

    #updateNavState() {
      if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.activeReelIndex <= 0);
      if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.activeReelIndex >= this.reels.length - 1);
    }

    #loadReelSrc(reel) {
      const video = reel.querySelector('[data-vrf-reel-video]');
      if (!video || video.currentSrc || video.getAttribute('src') || video.src || video.querySelector('source')) return video;

      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      const src = isMobile ? reel.dataset.vrfMobileSrc : reel.dataset.vrfSrc;

      this.#prepareVideo(video, this.modalMuted);

      if (src) {
        video.src = src;
        video.load();
      }

      return video;
    }

    #playReel(reel) {
      if (!this.modal.open) return;

      const video = this.#loadReelSrc(reel);
      if (!video) return;

      this.#prepareVideo(video, this.modalMuted);

      const playToken = this.modalPlaybackToken;
      const promise = video.play();

      if (promise && typeof promise.then === 'function') {
        promise
          .then(() => {
            if (!this.modal.open || playToken !== this.modalPlaybackToken) {
              this.#pauseReel(reel);
              return;
            }

            reel.classList.add('is-playing');
          })
          .catch(() => {
            if (!this.modal.open || playToken !== this.modalPlaybackToken) {
              this.#pauseReel(reel);
              return;
            }

            /* Autoplay with sound can be blocked — fall back to muted */
            if (!this.modalMuted) {
              this.modalMuted = true;
              this.modal.classList.remove('is-unmuted');
              video.muted = true;
              video.play()
                .then(() => {
                  if (!this.modal.open || playToken !== this.modalPlaybackToken) {
                    this.#pauseReel(reel);
                    return;
                  }

                  reel.classList.add('is-playing');
                })
                .catch(() => reel.classList.remove('is-playing'));
            } else {
              reel.classList.remove('is-playing');
            }
          });
      }
    }

    #pauseReel(reel) {
      const video = reel.querySelector('[data-vrf-reel-video]');
      if (video && !video.paused) video.pause();
      reel.classList.remove('is-playing');
    }

    #toggleReelPlayback(reel) {
      const video = reel.querySelector('[data-vrf-reel-video]');
      if (!video) return;

      if (video.paused) {
        this.#playReel(reel);
      } else {
        this.#pauseReel(reel);
      }
    }

    #initReelIntersection() {
      if (!('IntersectionObserver' in window)) return;

      this.reelObserver = new IntersectionObserver(
        (entries) => {
          if (!this.modal.open) return;

          for (const entry of entries) {
            const reel = entry.target;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              this.activeReelIndex = this.reels.indexOf(reel);
              this.#updateNavState();

              for (const other of this.reels) {
                if (other !== reel) this.#pauseReel(other);
              }

              this.#playReel(reel);
            }
          }
        },
        {
          root: this.reelsContainer,
          rootMargin: '0px',
          threshold: [0.6, 0.9]
        }
      );

      for (const reel of this.reels) {
        this.reelObserver.observe(reel);
      }
    }

    disconnectedCallback() {
      if (this.gridObserver) this.gridObserver.disconnect();
      if (this.reelObserver) this.reelObserver.disconnect();
      this.#stopAllReels(true);
      document.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('focus', this.handleWindowFocus);
    }
  }

  if ('customElements' in window && !customElements.get('video-review-grid')) {
    customElements.define('video-review-grid', VideoReviewGrid);
  }

  function bootVideoReviewAutoplay() {
    const cards = Array.from(document.querySelectorAll('[data-vrf-card]'));
    if (!cards.length) return;

    const isNearViewport = (card) => {
      const rect = card.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      return rect.bottom > -120 && rect.top < viewportHeight + 120 && rect.right > 0 && rect.left < viewportWidth;
    };

    const playCard = (card) => {
      const video = card.querySelector('[data-vrf-video]');
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.autoplay = true;
      video.preload = 'metadata';
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');

      if (video.dataset.vrfAutoplayBound !== 'true') {
        video.dataset.vrfAutoplayBound = 'true';
        video.addEventListener('playing', () => card.classList.add('is-playing'));
        video.addEventListener('pause', () => card.classList.remove('is-playing'));
        video.addEventListener('ended', () => card.classList.remove('is-playing'));
      }

      const promise = video.play();
      if (promise && typeof promise.then === 'function') {
        promise
          .then(() => {
            if (!video.paused) card.classList.add('is-playing');
          })
          .catch(() => card.classList.remove('is-playing'));
      } else if (!video.paused) {
        card.classList.add('is-playing');
      }
    };

    const syncVisibleCards = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const visibleCards = cards.filter((card) => {
        return card.querySelector('[data-vrf-video]') && isNearViewport(card);
      });

      for (const card of cards) {
        const video = card.querySelector('[data-vrf-video]');
        if (!video) continue;

        if (visibleCards.includes(card)) {
          window.setTimeout(() => playCard(card), visibleCards.indexOf(card) * 180);
        } else {
          if (!video.paused) video.pause();
          card.classList.remove('is-playing');
        }
      }
    };

    let ticking = false;
    const requestSync = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        syncVisibleCards();
      });
    };

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync, { passive: true });
    window.addEventListener('hashchange', requestSync, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) requestSync();
    });

    requestAnimationFrame(syncVisibleCards);
    window.setTimeout(syncVisibleCards, 400);
    window.setTimeout(syncVisibleCards, 1200);
    window.setTimeout(syncVisibleCards, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVideoReviewAutoplay);
  } else {
    bootVideoReviewAutoplay();
  }

  } catch(e) { console.error(e); }
})();
})();
